import { Typography } from "@drone-js/core";
import { VStack } from "apps/commons/components/Stack";
import isEmpty from "lodash/isEmpty";
import { memo } from "react";

interface Props {
    name: string;
    location: string;
}

export const PropertyName = memo<Props>(({ name, location }) => {
    return (
        <VStack gap="4">
            <Typography variant="body-default-strong" textColor="base.default">
                {name}
            </Typography>
            {!isEmpty(location) && (
                <Typography variant="caption-default" textColor="base.subtle">
                    {location}
                </Typography>
            )}
        </VStack>
    );
});
